import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select";
import InputNumber from "../components/InputNumber";
import Output from "../components/Output";

import { timberCompression } from "../../utils/services/calculators";
import { Text, useToast } from "@chakra-ui/react";

function TimberCompression({}) {
  const toast = useToast();
  // BENDING
  const [compressionInputs, setCompressionInputs] = useState({
    forest_type: "Nativa",
    timber: "Coníferas",
    timber_class: "D20",
    timber_type: "Madeira serrada",
    load_class: "Permanente",
    moisture_class: "1 (≤ 65%)",
    lx: "",
    ke_x: 1,
    ly: "",
    ke_y: 1,
    b: "",
    h: "",
    af: "",
    nsd: "",
  });
  const [compressionOutputs, setCompressionOutputs] = useState({
    fc0_d: "",
    l0_x: "",
    l0_y: "",
    lambd_x: "",
    lambd_y: "",
    tens_nc_d: "",
    lambd_rel_x: "",
    verification_x: "",
    lambd_rel_y: "",
    verification_y: "",
    memorial: {},
  });

  function updateCompressionInputs(name, value) {
    if (
      name === "forest_type" ||
      name === "timber" ||
      name === "timber_class" ||
      name === "timber_type" ||
      name === "load_class" ||
      name === "moisture_class"
    ) {
      if (value === "Nativa") {
        setCompressionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D20",
        }));
      } else if (value === "Plantada") {
        setCompressionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber"]: "Coníferas",
        }));
        setCompressionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      }
      if (value === "Coníferas") {
        setCompressionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      } else if (value === "Folhosas") {
        setCompressionInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D18",
        }));
      }
      setCompressionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else if (value === "") {
      setCompressionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setCompressionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setCompressionOutputs({
      fc0_d: "",
      l0_x: "",
      l0_y: "",
      lambd_x: "",
      lambd_y: "",
      tens_nc_d: "",
      lambd_rel_x: "",
      verification_x: "",
      lambd_rel_y: "",
      verification_y: "",
    });
  }

  function onCompressionCalculate() {
    if (
      compressionInputs["lx"] === "" ||
      compressionInputs["ly"] === "" ||
      compressionInputs["b"] === "" ||
      compressionInputs["h"] === "" ||
      compressionInputs["af"] === "" ||
      compressionInputs["nsd"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      compressionInputs["lx"] === 0 ||
      compressionInputs["ly"] === 0 ||
      compressionInputs["b"] === 0 ||
      compressionInputs["h"] === 0 ||
      compressionInputs["nsd"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      timberCompression(compressionInputs).then((response) => {
        setCompressionOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "timber-compression-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "timber-compression-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Compressão:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Floresta"
              elements={["Nativa", "Plantada"]}
              unit=""
              onChange={(e) =>
                updateCompressionInputs("forest_type", e.target.value)
              }
              value={compressionInputs["forest_type"]}
            />
            {compressionInputs["forest_type"] === "Plantada" && (
              <Select
                text="Madeira"
                elements={["Coníferas", "Folhosas"]}
                unit=""
                onChange={(e) =>
                  updateCompressionInputs("timber", e.target.value)
                }
                value={compressionInputs["timber"]}
              />
            )}
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Classe"
              elements={
                compressionInputs["forest_type"] === "Nativa"
                  ? ["D20", "D30", "D40", "D50", "D60"]
                  : compressionInputs["forest_type"] === "Plantada" &&
                      compressionInputs["timber"] === "Coníferas"
                    ? [
                        "C14",
                        "C16",
                        "C18",
                        "C20",
                        "C22",
                        "C24",
                        "C27",
                        "C30",
                        "C35",
                        "C40",
                        "C45",
                        "C50",
                      ]
                    : compressionInputs["forest_type"] === "Plantada" &&
                        compressionInputs["timber"] === "Folhosas"
                      ? ["D18", "D24", "D30", "D35", "D40", "D50", "D60", "D70"]
                      : []
              }
              unit=""
              onChange={(e) =>
                updateCompressionInputs("timber_class", e.target.value)
              }
              value={compressionInputs["timber_class"]}
            />
            <Select
              text="Classe de umid."
              elements={["1 (≤ 65%)", "2 (≤ 75%)", "3 (≤ 85%)", "4 (> 85%)"]}
              unit=""
              onChange={(e) =>
                updateCompressionInputs("moisture_class", e.target.value)
              }
              value={compressionInputs["moisture_class"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Tipo"
              elements={[
                "Madeira serrada",
                "Madeira roliça",
                "Madeira lamelada colada (MLC)",
                "Madeira lamelada colada cruzada (MLCC)",
                "Madeira laminada colada (LVL)",
                "Madeira recomposta",
              ]}
              unit=""
              onChange={(e) =>
                updateCompressionInputs("timber_type", e.target.value)
              }
              value={compressionInputs["timber_type"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Classe de carregamento"
              elements={[
                "Permanente",
                "Longa duração",
                "Média duração",
                "Curta duração",
                "Instantânea",
              ]}
              unit=""
              onChange={(e) =>
                updateCompressionInputs("load_class", e.target.value)
              }
              value={compressionInputs["load_class"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Lx"
              unit="cm"
              onChange={(e) => updateCompressionInputs("lx", e.target.value)}
            />
            <Select
              text="Kex"
              elements={[0.65, 0.8, 1.2, 1, 2.1, 2.4]}
              unit=""
              onChange={(e) => updateCompressionInputs("ke_x", e.target.value)}
              value={compressionInputs["ke_x"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Ly"
              unit="cm"
              onChange={(e) => updateCompressionInputs("ly", e.target.value)}
            />
            <Select
              text="Key"
              elements={[0.65, 0.8, 1.2, 1, 2.1, 2.4]}
              unit=""
              onChange={(e) => updateCompressionInputs("ke_y", e.target.value)}
              value={compressionInputs["ke_y"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateCompressionInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateCompressionInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="af"
              unit="cm²"
              onChange={(e) => updateCompressionInputs("af", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Nsd"
              unit="tf"
              onChange={(e) => updateCompressionInputs("nsd", e.target.value)}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onCompressionCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          <Output text="fc0,d" value={compressionOutputs["fc0_d"]} unit="MPa" />
          {compressionOutputs["l0_x"] === "" ? (
            <h4 className={styles.rowDescription}>L0,x =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"L0,x = " +
                compressionOutputs["l0_x"].toFixed(2) +
                " ≤ " +
                (40 * compressionInputs["h"]).toFixed(2) +
                " → "}
              {compressionOutputs["l0_x"] <= 40 * compressionInputs["h"]
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          {compressionOutputs["l0_y"] === "" ? (
            <h4 className={styles.rowDescription}>L0,y =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"L0,y = " +
                compressionOutputs["l0_y"].toFixed(2) +
                " ≤ " +
                (40 * compressionInputs["b"]).toFixed(2) +
                " → "}
              {compressionOutputs["l0_y"] <= 40 * compressionInputs["b"]
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          {compressionOutputs["lambd_x"] === "" ? (
            <h4 className={styles.rowDescription}>λx =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"λx = " + compressionOutputs["lambd_x"].toFixed(2) + " ≤ 140 → "}
              {compressionOutputs["lambd_x"] <= 140 ? "OK!" : "NÃO OK!"}
            </h4>
          )}
          {compressionOutputs["lambd_y"] === "" ? (
            <h4 className={styles.rowDescription}>λy =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"λy = " + compressionOutputs["lambd_y"].toFixed(2) + " ≤ 140 → "}
              {compressionOutputs["lambd_y"] <= 140 ? "OK!" : "NÃO OK!"}
            </h4>
          )}
          <Output
            text="σNc,d"
            value={compressionOutputs["tens_nc_d"]}
            unit="MPa"
          />
          {compressionOutputs["tens_nc_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {compressionOutputs["tens_nc_d"].toFixed(2) +
                " ≤ " +
                compressionOutputs["fc0_d"].toFixed(2) +
                " → "}
              {compressionOutputs["tens_nc_d"] <=
              compressionOutputs["fc0_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <h4>Estabilidade - Eixo X</h4>
          {compressionOutputs["lambd_rel_x"] === "" ? (
            <h4 className={styles.rowDescription}>λrel,x =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"λrel,x = " +
                compressionOutputs["lambd_rel_x"].toFixed(2) +
                " ≤ 0.3 → "}
              {compressionOutputs["lambd_rel_x"] <= 0.3 ? "OK!" : "NÃO OK!"}
            </h4>
          )}
          {compressionOutputs["lambd_rel_x"] !== "" &&
            compressionOutputs["lambd_rel_x"] > 0.3 && (
              <h4 className={styles.rowDescription}>
                {compressionOutputs["verification_x"].toFixed(2) + " ≤ 1 → "}
                {compressionOutputs["verification_x"] <= 1 ? "OK!" : "NÃO OK!"}
              </h4>
            )}
          <h4>Estabilidade - Eixo Y</h4>
          {compressionOutputs["lambd_rel_y"] === "" ? (
            <h4 className={styles.rowDescription}>λrel,y =</h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"λrel,y = " +
                compressionOutputs["lambd_rel_y"].toFixed(2) +
                " ≤ 0.3 → "}
              {compressionOutputs["lambd_rel_y"] <= 0.3 ? "OK!" : "NÃO OK!"}
            </h4>
          )}
          {compressionOutputs["lambd_rel_y"] !== "" &&
            compressionOutputs["lambd_rel_y"] > 0.3 && (
              <h4 className={styles.rowDescription}>
                {compressionOutputs["verification_y"].toFixed(2) + " ≤ 1 → "}
                {compressionOutputs["verification_y"] <= 1 ? "OK!" : "NÃO OK!"}
              </h4>
            )}
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {compressionOutputs["memorial"] &&
          Object.entries(compressionOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default TimberCompression;
